import React from 'react';
import { withAppContext, getToken } from '@ctsu/loader';
import { Header, HelpContainer, Footer } from '@ctsu/react-ctsu-ui';
import { NavLink } from 'react-router-dom';
import { NavSpine } from '@ctsu/nav-spine';
import buildInfoLock from './components/buildInfo/buildInfoLock';
import appRoutes from './routes/appRoutes';

function LogoutCmp() {
  return <NavLink to="/logout">Logout</NavLink>;
}
const ExternalComponent = (session) => <></>;
function HeaderComp(context) {
  const { application, session } = context;
  const { dbName } = application;
  return (
    <>
      <Header
        appName={process.env.REACT_APP_NAME}
        key="pd.header"
        coreVersion={process.env.REACT_APP_PD_API_VERSION}
        routes={appRoutes}
        subName="Protocol Deviations"
        // stickyData={stickyData}
        showSummary={false}
        logout={LogoutCmp}
        externalComponents={ExternalComponent}
        dbName={dbName}
        userPermissions={session && session.userPermissions}
        impersonateContext={context}
        userFirstLast={session && session.userFirstLast}
        fnToken={getToken}
        username={session && session.username}
        impersonateLevel={session && session.impersonateLevel}
        lastLogin={session && session.lastLogin}
        ctepId={session && session.ctepId}
        pwdExpiryDays={session && session.pwdExpiryDays}
      />

      <div id="skip-to-content" tabIndex="-1" className="invisible" />
    </>
  );
}

const buildInfo = {
  buildVersion: buildInfoLock.build_version,
  buildDate: buildInfoLock.build_date
};
function AppContent(props) {
  const { children, context } = props;
  const { application, session } = context;
  const { dbName } = application || [];

  const authenticated = context && !!getToken();
  let hasNavSpineAccess = false;
  if (authenticated && context && session) {
    hasNavSpineAccess = context.session.userGroups.includes('CTSU');
  }
  return (
    <>
      {hasNavSpineAccess ? (
        <NavSpine
          userContext={session}
          appRoot={process.env.REACT_APP_ORIGIN}
          appName={process.env.REACT_APP_NAME}
          getToken={getToken}
        />
      ) : null}
      {/* <HeaderComp /> */}
      {HeaderComp(context)}
      <div>
        <HelpContainer
          appName={process.env.REACT_APP_NAME}
          getToken={getToken}
          appUrl={process.env.REACT_APP_ORIGIN}
        />
      </div>

      <div className="main app-body">
        <div className="app-spacing">
          <div className="app-body-content">{children}</div>
        </div>
      </div>
      <Footer
        dbName={dbName || ''}
        buildInfo={buildInfo}
        releaseNotes={process.env.REACT_APP_RELEASE_NOTES}
      />
    </>
  );
}
export default withAppContext(AppContent);
